<script>
// import axios from "axios";

import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { ModelListSelect } from "vue-search-select";
import { mapGetters, mapActions, mapState } from "vuex";

/**
 * Advanced table component
 */
export default {
  page: {
    title: "Account Balance",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    ModelListSelect
  },
  data() {
    return {
      model_id:'',
      traserrors:{
        from:"",
        to:"",
        amount:""
      },
      transfer:{
        from:"",
        fromname:"",
        frombal:"",
        to:"",
        amount:"",
        balance:"",
        showheadre:false
      },
      title: "Account Balance",
      items: [
        {
          text: "Account Section",
          href: "#/",
        },
        {
          text: "Account Balance",
          active: true,
        },
      ],
      totalRows: 1,

      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100, 200, 1000],
      filter: null,
      todoFilter: null,
      filterOn: [],
      todofilterOn: [],
      sortDesc: false,
      fields: [
        {
          key: "index",
          sortable: true,
          label: "S/N",
        },
        {
          key: "branch.branchName",
          sortable: true,
          label: "BRANCH",
        },
        // {
        //   key: "modeType",
        //   sortable: true,
        //   label: "ACC TYPE",
        // },
        {
          key: "paymentMode.provider",
          sortable: true,
          label: "ACC PROVIDER",
        },
        {
          key: "paymentMode.modeNumber",
          sortable: true,
          label: "ACC NUMBER",
        },
        {
          key: "paymentMode.modeName",
          sortable: true,
          label: "ACC NAME",
        },
        {
          key: "balance",
          sortable: true,
          label: "	ACC BALANCE",
        },
         
      ],
    };
  },
  computed: {
    ...mapGetters("payments", ["AccountBalance","PaymentModes","PayModeStatus"]),
        // MAP STATE
    ...mapState("notification", [
      "notificationtype",
      "notification_message",
      "notification_show",
    ]),

       filterOutAccountFrom: function () {
     return this.PaymentModes.filter((element)=>{
         return element.id  != this.transfer.from
     })
    },

    /**
     * Total no. of records
     */

    rows() {
      return this.AccountBalance ? this.AccountBalance.length : 1;
    },

    /**
     * Todo list of records
     */
  },
  mounted() {
    // Set the initial number of items
    this.totalRows = this.AccountBalance ? this.AccountBalance.length : 1;
  },
   watch: {
    notification_show(newValue) {
      // Do whatever makes sense now
      if (newValue == true) {
        this.closeMode(this.model_id);
        if (this.notificationtype == "success") {
          this.$toast.success(this.notification_message.msg);
        } else {
          this.$toast.error(this.notification_message.msg);
        }
      }
    },
  },
  methods: {
    addCommas(){

      this.transfer.amount = this.thousandSeprator(this.transfer.amount)
      let balance = this.transfer.balance;
      let balancenum = parseInt(balance);

      let amt = this.transfer.amount;
      var amount = amt.replace(/,/g, '');
      let amountnum = parseInt(amount);
      if(amountnum >balancenum){
        this.traserrors.amount = "Insuffient Balance for the requested transfer amount"
      }else{
          this.traserrors.amount = ""
      }

    },
    thousandSeprator(m) {
      if (m !== "" || m !== undefined || m !== 0 || m !== "0" || m !== null) {
        return m
          .toString()
          .replace(/\D/g, "")
          .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      } else {
        return m;
      }
    },
    ...mapActions({
      FetchAccountBalance: "payments/fetchAccountBalance",
      FetchPaymentModes: "payments/fetchPaymentModes",
      TransferMoney: "payments/transferMoney",
    }),
resetForm(){
  this.transfer ={
        from:"",
        fromname:"",
        frombal:"",
        to:"",
        amount:"",
        balance:"",
        showheadre:false
      }
},
    setBalance(){
      let account = this.PaymentModes.filter((element)=>{
         return element.id  == this.transfer.from
     });
     let acctdetails = account[0];
     this.transfer.showheadre = true
     this.transfer.fromname =  acctdetails.mode
     this.transfer.balance =  acctdetails.balance
    },

    transfermoney(){
      if(this.transfer.from == ""){
      this.traserrors.from == "Please select trasfer from account"
      return
      }else if(this.transfer.to == ""){
    this.traserrors.to == "Please select trasfer to account"
    return
      }else if(this.transfer.amount == ""){
    this.traserrors.amount == "Please enter transfer amount"
    return
      }else{
        this.traserrors.from == ""
        this.traserrors.to == ""
        this.traserrors.amount == ""
      }

      this.model_id = "transfer_money"
      this.TransferMoney(this.transfer)
    },
    /**
     * Search the table data with search input
     */
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },

    closeMode(model_id) {
      this.$nextTick(() => {
        this.$bvModal.hide(model_id);
      });
    },
  },
  created() {
    this.FetchAccountBalance();
    this.FetchPaymentModes();
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <Toasts
      :show-progress="true"
      :rtl="true"
      :max-messages="20"
      :time-out="3000"
      :closeable="false"
      :solid="true"
    ></Toasts>
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <button @click="resetForm()" v-b-modal.transfer_money class="mb-4 btn btn-primary float-end"><i class="fa fa-refresh"></i> Transfer Money</button>
            <br/>
            <br/>
            <div class="row mt-4">
              <div class="col-sm-12 col-md-6">
               
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Show&nbsp;
                    <b-form-select
                      class="form-select form-select-sm"
                      v-model="perPage"
                      size="sm"
                      :options="pageOptions"
                    ></b-form-select
                    >&nbsp;entries
                  </label>
                </div>
              </div>
              <!-- Search -->
              <div class="col-sm-12 col-md-6">
            
                <div id="tickets-table_filter" class="dataTables_filter text-md-end">
                  <label class="d-inline-flex align-items-center">
                    Search:
                    <b-form-input
                      v-model="filter"
                      type="search"
                      placeholder="Search..."
                      class="form-control form-control-sm ms-2"
                    ></b-form-input>
                  </label>
                </div>
              </div>
              <!-- End search -->
            </div>
            <!-- Table -->
            <div class="table-responsive mb-0">
     
              <b-table
                class="datatables"
                :items="AccountBalance ? AccountBalance : []"
                :fields="fields"
                responsive="sm"
                :per-page="perPage"
                :current-page="currentPage"
                :sort-desc.sync="sortDesc"
                :filter="filter"
                :filter-included-fields="filterOn"
                @filtered="onFiltered"
              >
                <template #cell(index)="data">
                  {{ data.index + 1 }}
                </template>
              
              </b-table>
              <div style="text-align: center;">
                <h3 v-if="!AccountBalance" class="text-primary">
                  <b-spinner
                      class="m-0"
                      variant="primary"
                      role="status"
                  ></b-spinner>
                  Please wait...
                </h3>
              </div>
            </div>
            <div class="row">
              <div class="col">
                <div class="dataTables_paginate paging_simple_numbers float-end">
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <b-pagination
                      v-model="currentPage"
                      :total-rows="rows"
                      :per-page="perPage"
                    ></b-pagination>
                  </ul>
                </div>
              </div>
            </div>

            <!-- TRANSFER MONEY MODEL -->
  <b-modal id="transfer_money" title="TRANSFER MONEY" hide-footer>
  <div class="alert alert-success" role="alert" v-show="transfer.showheadre">
  <center><h6 class="alert-heading">Transfer from</h6></center>
<h5 class="alert-heading">{{transfer.fromname}}</h5>
  <h6>Current balance: {{thousandSeprator(transfer.balance)}} /=</h6>

</div>
    <div class="form-group mb-2">
                     <label>FROM</label>
                        <model-list-select
                        @input="setBalance()"
                        :list="PaymentModes ? PaymentModes : []"
                        v-model="transfer.from"
                        option-value="id"
                        option-text="mode"
                        placeholder="select payment mode"
                      >
    </model-list-select>
    <span class="text-danger">{{traserrors.from}}</span>
    </div>
      <div class="form-group mb-2">
    <label>Transfer Amount</label>
      <input @input="addCommas()" placeholder="Enter transfer amount" v-model="transfer.amount" class="form-control"/>
      <span class="text-danger">{{traserrors.amount}}</span>
    </div>
    <div class="form-group mb-2">
    <label>TO</label>
                        <model-list-select
                        :list="filterOutAccountFrom ? filterOutAccountFrom : []"
                        v-model="transfer.to"
                        option-value="id"
                        option-text="mode"
                        placeholder="select payment mode"
                      >
    </model-list-select>
        <span class="text-danger">{{traserrors.to}}</span>
    </div>

       <div class="modal-footer">
        <button   @click="closeMode('transfer_money')" type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
         <button v-if="traserrors.amount || traserrors.from || traserrors.to" disabled type="button" class="btn btn-primary">Transfer
            </button>
        <button v-else @click="transfermoney()" type="button" class="btn btn-primary">Transfer   
         <div v-if="PayModeStatus" class="spinner-grow spinner-grow-sm"></div>      
            </button>
      </div>
  </b-modal>
            <!-- END TRANSFER MOINEY MODEL -->
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>
